<template>
    <aside id="head-nav" v-if="isVisible" :class="isSlide ? 'open' : 'close'">
        <div id="menu-dim" @click="doMenuClose"></div>
        <div class="menu-wrap">
            <div class="menu-container">
                <div class="menu-head">
                    <h2 class="store-logo"><img src="@/assets/images/common/logo_vertical.svg" alt="Starfield MARKET" /></h2>
                    <div class="store-info">
                        <dl class="info-hours">
                            <dt>
                                <strong class="blind">점포명</strong>
                                <span>{{ storeName }}</span>
                            </dt>
                            <dd>{{ storeInfo.openingHours }}</dd>
                        </dl>
                        <ul class="info-noti">
                            <li>{{ storeName }} 영업시간 {{ storeInfo.openingHours }}</li>
                            <li>브랜드별 영업시간 상이</li>
                            <li>이번달 휴점일: {{ holidays }}</li>
                        </ul>
                    </div>
                </div>
                <div class="menu-list">
                    <ul>
                        <li><router-link :to="{ path: '/', query: { ...currentQuery } }" @click="doMenuClose">HOME</router-link></li>
                        <li>
                            <router-link :to="{ path: '/about', query: { ...currentQuery } }" @click="doMenuClose">스타필드 마켓 소개</router-link>
                        </li>

                        <li><router-link :to="{ path: '/store', query: { ...currentQuery } }" @click="doMenuClose">매장안내</router-link></li>
                        <li>
                            <router-link :to="{ path: '/store/fnb', query: { ...currentQuery } }" @click="doMenuClose">레스토랑&카페</router-link>
                        </li>
                        <li>
                            <router-link :to="{ path: '/store/facility', query: { ...currentQuery } }" @click="doMenuClose">편의시설</router-link>
                        </li>
                        <li><a href="javascript:;" @click.prevent="doMoveToMap">지도보기</a></li>
                    </ul>
                </div>
                <div class="menu-footer">
                    <p>
                        MY LOCAL DELIGHT,<br />
                        스타필드 마켓과 함께 할<br />
                        브랜드 컨텐츠사의 다양한 제안을 기다립니다.<br />
                    </p>
                    <dl>
                        <dt>제휴문의</dt>
                        <dd><a href="mailto:sfm_marketing@emart.com">sfm_marketing@emart.com</a></dd>
                    </dl>
                </div>
                <div class="menu-close">
                    <button type="button" aria-label="메뉴창 닫기" @click="doMenuClose"></button>
                </div>
            </div>
        </div>

        <div class="black-bg" v-if="modalMapVisible">
            <div class="white-bg">
                <MapView ref="modalMap" @close="modalMapOpenClose(false)" />
            </div>
        </div>
    </aside>
</template>

<script setup>
    import { computed, onBeforeUnmount, onMounted, ref, toRef, toRefs, watch, nextTick } from 'vue';
    import dayjs from 'dayjs';
    import 'dayjs/locale/ko';
    import { useRootStore } from '@/stores/modules';
    import MapView from '@/views/MapView.vue';

    dayjs.locale('ko');

    const props = defineProps({
        isSlide: {
            type: Boolean,
        },
    });
    const $emit = defineEmits(['close']);

    const rootStore = useRootStore();
    const { storeName, storeInfo, selectedBranchId } = toRefs(rootStore);
    const isSlide = toRef(props, 'isSlide');

    const currentQuery = computed(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const query = {};

        urlParams.forEach((value, key) => {
            query[key] = value;
        });

        if (!query.branch && selectedBranchId.value) {
            query.branch = selectedBranchId.value;
        }

        return query;
    });
    const holidays = computed(() => {
        const thisMonth = dayjs().format('YYYYMM');

        if (!storeInfo.value.holidayList) {
            return '';
        }

        const formattedList = storeInfo.value.holidayList
            ?.filter((item) => {
                return item.startsWith(thisMonth);
            })
            .map((item) => {
                const date = dayjs(item, 'YYYYMMDD');
                return date.format('MM/DD (dd)');
            });

        return formattedList.join(', ');
    });

    const isVisible = ref(false);
    const modalMapVisible = ref(false);
    const modalMap = ref(null);

    // 메뉴 닫기
    const doMenuClose = () => {
        $emit('close');
    };
    // 메뉴 Toggle
    const toggleBodyScroll = (slide) => {
        const body = document.body;
        if (slide) {
            isVisible.value = true;
            body.classList.add('no-scroll');
        } else {
            setTimeout(() => {
                isVisible.value = false;
                body.classList.remove('no-scroll');
            }, 200);
        }
    };
    // 맵페이지로 이동
    const doMoveToMap = async () => {
        // 모달인 경우 Body Scroll 표시안함
        document.body.classList.add('no-scroll');

        // 맵표시
        modalMapVisible.value = true;

        // 맵 초기화
        // await nextTick();
        if (modalMap.value && modalMap.value.setMapEnv) {
            modalMap.value.setMapEnv();
        }
    };
    // 맵보이고 감추기
    const modalMapOpenClose = (visible) => {
        modalMapVisible.value = visible;
        if (!visible) {
            // 바깥부분 Scroll처리
            document.body.classList.remove('no-scroll');
        }
    };
    const closePopComp = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.removeEventListener('popstate', bindPopComp);
    };
    function bindPopComp(e) {
        // 모달 맵이 활성화되는 경우
        if (modalMapVisible.value) {
            modalMapOpenClose(false);
            closePopComp(e);
        } else {
            closePopComp(e);
        }
    }

    watch(isSlide, (to) => {
        toggleBodyScroll(to);
        if (to) {
            // 슬라이드 열릴때 점포 조회 호출
            rootStore.getStoreInfo();
            console.log();
        }
    });
    onMounted(() => {
        // 메뉴상태 설정
        toggleBodyScroll(props.isSlide);

        window.addEventListener('popstate', bindPopComp);
    });
    onBeforeUnmount(() => {
        document.body.classList.remove('no-scroll');
    });
</script>

<script>
    export default {
        name: 'SlideMenu',
    };
</script>
